// Copy of LfcEngine.checkConstraint() in LfcEngine.js in lfc-frontend
export default function checkConstraint(selectedValues, constraintsRules) {
  const DENYFOR = 'DENYFOR'
  const NEEDSANYOF = 'NEEDSANYOF'
  const RECOMMENDED = 'recommendedFor'
  let ruleCheckResult = []
  let ruleHolder = []
  let masterRuleFound = 0

  // LfcEngine.constraintRuleset.rules.forEach(function (rule) {
  constraintsRules.forEach(function (rule) {
    let conCatHolder = []
    ruleHolder = '{"ruleId":' + rule.ruleId + ',"valueId":' + rule.valueId + ','
    let t = ckon(rule, selectedValues, 'needConditions', NEEDSANYOF)
    if (t !== undefined) conCatHolder.push(t)
    t = ckon(rule, selectedValues, 'denyForConditions', DENYFOR)
    if (t !== undefined) conCatHolder.push(t)
    conCatHolder.push(ckon(rule, selectedValues, 'recommendedForConditions', RECOMMENDED))
    ruleHolder = ruleHolder + conCatHolder + '}'
    ruleCheckResult.push(ruleHolder)
  })

  function ckon(rule, selVals, type, name) {
    let vs = []
    let rval = undefined
    let currentRule = rule[type]
    let foundRule = 0

    currentRule.forEach(function (rule) {
      if (rule.type === 'AND') {
        selVals.forEach(function (selectedValue) {
          if (lookupId(rule.valueIdList, selectedValue)) {
            vs.push('{"type": "AND", "valueIdList":' + JSON.stringify(rule.valueIdList) + '}')
            foundRule = 1
            masterRuleFound = 1
          }
        })
      } else if (rule.type === 'SINGLE') {
        selVals.forEach(function (selectedValue) {
          if (lookupId(rule.valueId, selectedValue)) {
            vs.push('{"type": "SINGLE", "valueId":' + JSON.stringify(rule.valueId) + '}')
            foundRule = 1
            masterRuleFound = 1
          }
        })
      }
    })

    if (foundRule === 1) {
      rval = []
      rval.push('"checkStatus":' + '"' + name + '"')
      rval.push('"decisionConditions":[' + vs + ']')
    } else if (foundRule === 0 && type === 'recommendedForConditions') {
      rval = []
      if (masterRuleFound === 0) {
        rval.push('"checkStatus":' + '"OK"')
        rval.push('"decisionConditions":[]')
      }
      rval.push('"' + name + '":' + '{}')
    }

    return rval
  }

  function lookupId(valueIdList, selectedValue) {
    if (valueIdList.isArray) {
      if (valueIdList.indexOf(selectedValue)) {
        return true
      }
    } else {
      if (valueIdList === selectedValue) {
        return true
      }
    }
    return false
  }

  if (ruleCheckResult.length < 1) {
    return JSON.parse('[]')
  } else {
    return JSON.parse('[' + ruleCheckResult + ']')
  }
}
